<template>
  <fragment>
    <template v-if="hasData">
      <slot />
    </template>

    <div
      v-else
      class="dash-card-content-fallback"
    >
      <emerald-icon
        data-testid="icon-content-fallback"
        icon="dashboard"
      />
      <emd-text
        color="#72737A"
        data-testid="text-content-fallback"
      >
        {{ $t('textContentFallback') }}
      </emd-text>
    </div>
  </fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'
import { EmdText, EmeraldIcon } from 'emerald-vue/src/components'

export default {
  name: 'DashCardContentFallback',

  components: {
    Fragment,
    EmeraldIcon,
    EmdText
  },

  props: {
    hasData: Boolean
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "textContentFallback": "Não encontramos dados para o período selecionado."
    },
    "en-US": {
      "textContentFallback": "We found no data for the selected period."
    }
  }
  </i18n>

<style scoped>
.dash-card-content-fallback {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  height: 280px;
}

.dash-card-content-fallback > div {
  text-align: center;
}
</style>
